import { type HttpEvent, type HttpHandlerFn, type HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '../services/environment.service';
import { type Observable, catchError, throwError } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

export const logRequestInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const environmentService = inject(EnvironmentService);

    if (!environmentService.verboseLogs) {
        return next(req);
    }

    const uuid = uuidv4();

    // eslint-disable-next-line no-console
    console.debug(JSON.stringify({
        msg: 'http request: starting',
        level: 'DEBUG',
        target: req.url,
        timestamp: Date.now(),
        identifier: uuid,
    }));

    return next(req).pipe(
        catchError(error => {
            // eslint-disable-next-line no-console
            console.debug(JSON.stringify({
                msg: 'http request: failure',
                level: 'DEBUG',
                target: req.url,
                statusCode: error.status,
                statusText: error.statusText,
                timestamp: Date.now(),
                identifier: uuid,
            }));

            return throwError(() => error);
        }),
    );
};
